<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/hello' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>数据更新管理</el-breadcrumb-item>
      <el-breadcrumb-item>总计统计数据更新管理</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card style="margin-top:15px;">
      <el-form
        ref="queryForm"
        :model="userSearchData"
        size="small"
        :inline="true"
        label-width="68px"
      >
        <el-form-item label="用户ID">
            <el-input
              v-model="userSearchData.user_id"
              placeholder="请输入用户ID"
              size="small"
              clearable
              style="width:150px;"
            ></el-input>
        </el-form-item>
        <el-form-item label="App类型">
            <el-select placeholder="请选择App类型"  v-model="userSearchData.app_id">
                <el-option
                  v-for="item in appids"
                  :key="item.app_id"
                  :label="item.name"
                  :value="item.app_id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="searchDataInfo()"
            >搜索</el-button>
          <el-button
            size="mini"
            type="primary"
            icon="el-icon-plus"
            @click="addversion"
            >新增</el-button>
        </el-form-item>
      </el-form>
      <!-- 表格 -->
      <el-table v-loading="pageloading" border :data="versionListData" stripe style="width: 100%">
        <el-table-column prop="Id" label="序列号" width="100"></el-table-column>
        <el-table-column prop="app_id" label="应用名称" width="100">
          <template slot-scope="scope">
            {{
              getAppName(scope.row.app_id)
            }}
          </template>
        </el-table-column>
        <el-table-column prop="channel_id" label="版本渠道名称" width="100">
          <template slot-scope="scope">
            {{
              getChannelName(scope.row.channel_id)
            }}
          </template>
        </el-table-column>
        <el-table-column prop="user_id" label="用户ID" width="100"></el-table-column>
        <el-table-column prop="yx_types_id" label="总计统计数据类型" width="100">
            <template slot-scope="scope">
              {{
                getDataTypsData(scope.row.yx_types_id)
              }}
            </template>
          </el-table-column>
        <el-table-column prop="status" label="任务状态" width="100">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.status == 0">待处理</el-tag>
            <el-tag type="success" v-if="scope.row.status == 1">处理中</el-tag>
            <el-tag type="success" v-if="scope.row.status == 2">处理成功</el-tag>
            <el-tag type="success" v-if="scope.row.status == 3">处理失败</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="auto_type" label="计算方式" width="100">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.auto_type == 0">不自动计算</el-tag>
            <el-tag type="success" v-if="scope.row.auto_type == 1">自动计算</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="data_type" label="计算类型" width="100">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.data_type == 0">日总计</el-tag>
            <el-tag type="success" v-if="scope.row.data_type == 1">月总计</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="price" label="传入的值" width="100">
        </el-table-column>
        <el-table-column prop="today_date" label="日期" width="80">
        </el-table-column>
        <el-table-column prop="month_date" label="月份" width="100">
        </el-table-column>
        <el-table-column prop="create_time" label="创建时间"  width="120">
          <template slot-scope="scope">
            {{changeDateFormat(scope.row.create_time)}}
          </template>
        </el-table-column>
        <el-table-column prop="update_time" label="更新时间"  width="120">
          <template slot-scope="scope">
            {{changeDateFormat(scope.row.update_time)}}
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页功能 -->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
      >
      </el-pagination>
      <!-- 分页功能 -->
    </el-card>

    <!-- 添加版本弹框 -->
    <el-dialog v-loading="editpageloading" title="新增信息" :visible.sync="addVisible" width="50%">
      <el-form
        :model="addruleForm"
        ref="addruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="App类型">
            <el-select placeholder="请选择App类型"  v-model="addruleForm.app_id">
                <el-option
                  v-for="item in appids"
                  :key="item.app_id"
                  :label="item.name"
                  :value="item.app_id">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="计算类型" prop="data_type">
          <el-radio-group v-model="addruleForm.data_type">
            <el-radio label="0">日总计</el-radio>
            <el-radio label="1">月总计</el-radio>
          </el-radio-group>
        </el-form-item>        
        <el-form-item label="日期" prop="today_date">
          <el-radio-group v-model="isSelectDate">
            <el-radio-button :label="true">选择日期</el-radio-button>
            <el-radio-button :label="false">不选择日期</el-radio-button>
          </el-radio-group>
          <el-date-picker
            v-model="addruleForm.today_date"
            style="width: 220px"
            value-format="yyyy-MM-dd"
            type="date"
            placeholder="选择日期"
            :disabled="!isSelectDate"
          />
        </el-form-item>
        <el-form-item label="月份" prop="month_date">
          <el-date-picker
            v-model="addruleForm.month_date"
            style="width: 220px"
            value-format="yyyy-MM"
            type="month"
            placeholder="选择月份"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addsubmitForm('addruleForm')"
            >添加内容</el-button
          >
          <el-button @click="addresetForm('addruleForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 添加版本弹框 -->
  </div>
</template>

<script>
// import { changeDateFormat } from "@/utils/util";
import { getCookie } from '../../utils/util';
import { getcurrentTime } from "@/utils/public";
import { isString } from '../../utils/util';
export default {
  data() {
    return {
      pageloading: false,
      editpageloading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0, //请求列表的总条数
      userSearchData: {
        user_id: "",
        app_id:"",
        channel_id: "",
        yx_types_id: "",
        status: "",
        time: ""
      },
      isSelectDate: false,
      // 添加版本信息数据
      addruleForm: {
        app_id:"",
        channel_id: 0,
        yx_types_id: "",
        user_id: "",
        name: "",
        tb_name: "",
        tb_item_name: "",
        status: 0,
        data_type: 0,
        auto_type: 1
      },
      // 修改版本信息数据
      editruleForm: {
        id: "",
        user_id: "",
        name: "",
        tb_name: "",
        tb_item_name: "",
        status: 0,
        data_type: 0,
        auto_type: 0
      },
      dataTypes: [
        {
          Id: "",
          name: "",
        }
      ],
      appids: [
        {
          app_id: "",
          name: "",
        }
      ],
      channelids: [
        {
          channel_id: "",
          channel_name: "",
        }
      ],
      tableData: [],
      versionListData: [],
      addVisible: false,
      editVisible: false
    };
  },

  mounted() {
    this.searchAllAppidsData();
    this.searchChannelIdsData();
    this.searchAllDataTypsData();
  },

  methods: {
    changeDateFormat(time, format = 'YYYY-MM-DD hh:mm:ss') {
      if(!time) return '';
      var datetime = new Date(time);
      var o = {
          'Y+': datetime.getFullYear(),
          "M+": datetime.getMonth() + 1,
          "D+": datetime.getDate(),
          "h+": datetime.getHours(),
          "m+": datetime.getMinutes(),
          "s+": datetime.getSeconds(),
          "q+": Math.floor((datetime.getMonth() + 3) / 3),
          "S": datetime.getMilliseconds()
      };
      if (/(Y+)/.test(format)) format = format.replace(RegExp.$1, (datetime.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o) {
          if (new RegExp("(" + k + ")").test(format)) {
              format = format.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
          }
      }
      return format;
    },
    getAppName(item) {
      var string = ``;
      if (item != null && this.appids != null) {
        for(var i=0; i<this.appids.length; i++) {
          var itemObject = this.appids[i];
          if (itemObject.app_id == item) {
            string = itemObject.name;
            break;
          }
        }
      }
      return string;
    },
    async searchAllAppidsData() {
      this.$axios
      .post("/3699BIApi/AppId/SearchAllData", {})
      .then(res => {
        if (res.data.code == 200) {
          var array = res.data.list;
          var resultData = [];
          var fob = new Object();
          fob["app_id"] = "";
          fob["name"] = "不选择";
          resultData.push(fob);
          for(var i = 0; i < array.length; i++) {
            let itemObject = array[i];
            var ob = new Object();
            for(var k in itemObject) {
                ob[k] = itemObject[k];
            }
            resultData.push(ob);
          }
          this.appids = resultData;
        }
      });
    },
    getChannelName(item) {
      var string = ``;
      if (isString(item)) {
        for(var i=0; i<this.channelids.length; i++) {
          var itemObject = this.channelids[i];
          if (itemObject.channel_id == item) {
            string = itemObject.name;
            break;
          }
        }
      }      
      return string;
    },
    async searchChannelIdsData() {
      this.$axios
      .post("/3699BIApi/ChannelId/SearchAllData", {})
      .then(res => {
        if (res.data.code != 200) {
          this.$message.error(`查询失败:${res.data.msg}`);
          return;
        }
        var array = res.data.list;
        var resultData = [];
        var fob = new Object();
        fob["channel_id"] = "";
        fob["name"] = "不选择";
        resultData.push(fob);
        for(var i = 0; i < array.length; i++) {
          let itemObject = array[i];
          var ob = new Object();
          for(var k in itemObject) {
              ob[k] = itemObject[k];
          }
          resultData.push(ob);
        }
        this.channelids = resultData;
      });
    },
    async searchAllDataTypsData() {
        this.$axios
        .post("/3699BIApi/DataTypeConfig/AllSearchData",{
          type: Number.parseInt(0),
          pageSize: 50
        })
        .then(res => {
            var array = res.data.list;
            var resultData = [];
            for(var i = 0; i < array.length; i++) {
                let itemObject = array[i];
                var ob = new Object();
                for(var k in itemObject) {
                    ob[k] = itemObject[k];
                }
                resultData.push(ob);
            }
            this.dataTypes = resultData;
        });
      },
      getDataTypsData(item) {
        var string = ``;
        if (isString(item)) {
          for(var i=0; i<this.dataTypes.length; i++) {
            var itemObject = this.dataTypes[i];
            if (itemObject.id == item) {
              string = itemObject.name;
              break;
            }
          }
        }      
        return string;
      },
    // 添加用户弹框
    addversion() {
      this.addVisible = true;
    },
    // 添加用户按钮
    addsubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let time = getcurrentTime();
          this.addruleForm.create_time = time;
          console.log(this.addruleForm);
          //添加版本
          this.addVersionData(this.addruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 重置添加用户
    addresetForm(formName) {
      this.$refs[formName].resetFields();
    },

    // 点击编辑行内容并更改数据
    edit(data) {
      this.editVisible = true;
      for(var k in data) {
        this.editruleForm[k] = data[k];
      }
      this.editruleForm.id = Number.parseInt(data.Id);
      this.editruleForm.app_name = this.getAppName(data.app_id);
      this.editruleForm.name = this.getChannelName(data.channel_id);
    },
    editsubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.editVisible = false;
          this.updateDataInfo(this.editruleForm);
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    editresetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.searchData(this.userSearchData);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.searchData(this.userSearchData);
    },
    async addVersionData(requestObject) {
      if (this.dataTypes.length > 0 ) {
        this.addruleForm.yx_types_id = this.dataTypes[0].Id;
      }

      if (!this.isSelectDate) {
        this.addruleForm.today_date = "";
      }
      
      this.editpageloading = true;
      this.$axios
      .post("/3699BIApi/UserTaskData/AddData",{
          app_id: Number.parseInt(requestObject.app_id),
          channel_id: Number.parseInt(requestObject.channel_id),
          user_id: Number.parseInt(requestObject.user_id),
          yx_types_id: Number.parseInt(requestObject.yx_types_id),
          status: Number.parseInt(requestObject.status),
          price: Number.parseFloat(requestObject.price),
          today_date: requestObject.today_date,
          auto_type: Number.parseInt(requestObject.auto_type),
          month_date: requestObject.month_date,
          data_type: Number.parseInt(requestObject.data_type)
      })
      .then(res => {
        this.editpageloading = false;
        if (res.data.code == "200") {
          this.addVisible = false;
          this.searchDataInfo();
          this.$message('添加成功！');
        }
        else {
          console.log(res.data.message);
          this.$message.error(`添加失败:${res.data.message}`);
        }
      });
    },
    async searchData(requestObject) {
      this.$axios
      .post("/3699BIApi/UserTaskData/SearchData",{
          app_id: Number.parseInt(requestObject.app_id),
          channel_id: Number.parseInt(requestObject.channel_id),
          user_id: Number.parseInt(requestObject.user_id),
          status: Number.parseInt(requestObject.status),
          today_date: requestObject.today_date,
          month_date: requestObject.month_date,
          auto_type: Number.parseInt(requestObject.auto_type),
          currentPage: this.currentPage,
          pageSize: this.pageSize,
          create_time: requestObject.time[0],
          update_time: requestObject.time[1]
      })
      .then(res => {
          this.pageloading = false;
          this.tableData = res.data.list;
          this.total = res.data.total;
          this.updateCurrpageData();
      });
    },
    searchDataInfo() {
      this.pageloading = true;
      this.searchData(this.userSearchData);
    },
    updateCurrpageData() {
      var arrays = [];
      var i = 0;
      var endi = this.total - (this.currentPage-1) * this.pageSize;
      if (endi > this.pageSize) {
        endi = this.pageSize;
      }
      console.log(`updateCurrpageData ${endi} 条`);
      for(; i<endi; i++) {
        if (i < this.total) {
          var itemObject = this.tableData[i];
          arrays.push(itemObject);
        }
      }
      
      this.versionListData = arrays.filter(val => {
        return val;
      });
    },
    async deleteDataInfo(data) {
      this.deleteData(data);
    },  
    // 删除
    async deleteData(data) {
      try {
        let msg = await this.$confirm("确认删除吗?");
        if (msg =  `confirm`) {
          this.deleteDataApi(data);
        }
      } catch (error) {
        return console.log("出错了：" + error);
      }
    },
  }
};
</script>

<style lang="sass" scoped></style>
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         


// WEBPACK FOOTER //
// src/views/UpdateTask/UserTaskData.vue